var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModelIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 21,
    viewBox: "0 0 31 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 17.2C27.2 18.8569 25.8568 20.2 24.2 20.2C22.5431 20.2 21.2 18.8569 21.2 17.2C21.2 15.5432 22.5431 14.2 24.2 14.2C25.8568 14.2 27.2 15.5432 27.2 17.2Z",
    stroke: "#11334E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 17.1961C25.2 17.7484 24.7522 18.1961 24.2 18.1961C23.6477 18.1961 23.2 17.7484 23.2 17.1961C23.2 16.6438 23.6477 16.1961 24.2 16.1961C24.7522 16.1961 25.2 16.6438 25.2 17.1961Z",
    stroke: "#11334E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 17.2C10.2 18.8569 8.85681 20.2 7.19995 20.2C5.5431 20.2 4.19995 18.8569 4.19995 17.2C4.19995 15.5432 5.5431 14.2 7.19995 14.2C8.85681 14.2 10.2 15.5432 10.2 17.2Z",
    stroke: "#11334E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19995 17.1961C8.19995 17.7484 7.75224 18.1961 7.19995 18.1961C6.64767 18.1961 6.19995 17.7484 6.19995 17.1961C6.19995 16.6438 6.64767 16.1961 7.19995 16.1961C7.75224 16.1961 8.19995 16.6438 8.19995 17.1961Z",
    stroke: "#11334E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 17.2V4.70001M19.7 17.2H10.2M19.7 17.2H21.2M19.7 4.70001V1.70001C19.7 1.14773 19.2522 0.700012 18.7 0.700012H1.69995C1.14767 0.700012 0.699951 1.14773 0.699951 1.70001V16.2C0.699951 16.7523 1.14767 17.2 1.69995 17.2H4.19995M19.7 4.70001H24.2M24.2 4.70001H25.2509C25.5365 4.70001 25.8085 4.82216 25.9983 5.03565L29.4474 8.91585C29.6101 9.0989 29.7 9.3353 29.7 9.58021V10.2M24.2 4.70001V9.20001C24.2 9.7523 24.6477 10.2 25.2 10.2H29.7M29.7 10.2V16.2C29.7 16.7523 29.2522 17.2 28.7 17.2H27.2",
    stroke: "#11334E",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelIcon1);
export default __webpack_public_path__ + "static/media/modelIcon1.d68779bd3c8ee20bdc7a01d6fbd989d8.svg";
export { ForwardRef as ReactComponent };